import { computed } from 'vue';
import { useUser } from '@clerk/vue';

const WORKSPACE_CREATOR_ROLES = ['admin', 'partner'];

export function useUserRole() {
  const { user } = useUser();

  const role = computed(() => user.value?.publicMetadata?.role ?? null);
  const isAdmin = computed(() => role.value === 'admin');
  const isPartner = computed(() => role.value === 'partner');
  const canCreateWorkspaces = computed(() =>
    WORKSPACE_CREATOR_ROLES.includes(role.value)
  );

  return { role, isAdmin, isPartner, canCreateWorkspaces };
}
